import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox';

import InputValueProps from '../../../../../prop-types/input-value-props';
import classnames from 'classnames';
import { INT_PARAMETER } from '../../../../../constants/parameter-name-for-update';
import style from './style.module.less';
import messages from './messages';

const HoldOrderFor = ({ inputValueProps, onChange, hasError, label }) => {
  const { intParameter } = inputValueProps;
  const isIndefinite = intParameter === null;
  const [inputValue, setInputValue] = useState(isIndefinite ? '' : (intParameter ?? ''));
  const [holdIndefinitely, setHoldIndefinitely] = useState(isIndefinite);

  const onValueChange = useCallback(
    (e) => {
      setInputValue(e?.target?.value);
    },
    [setInputValue],
  );

  const onBlur = useCallback(() => {
    if (!holdIndefinitely) {
      onChange({
        [INT_PARAMETER]: inputValue,
      });
    }
  }, [onChange, inputValue, holdIndefinitely]);

  const onIndefinitelyChange = useCallback(
    (checked) => {
      setHoldIndefinitely(checked);
      if (checked) {
        onChange({
          [INT_PARAMETER]: null,
        });
      } else if (inputValue !== '' && inputValue !== null && inputValue !== undefined) {
        onChange({
          [INT_PARAMETER]: inputValue,
        });
      }
    },
    [onChange, inputValue],
  );

  return (
    <div className={style['hold-order-container']}>
      <div className={classnames(style['multi-control-row'], style['hold-order-for'], { [style.error]: hasError })}>
        <div>{label}</div>
        <div className={style['control-wrap']}>
          <FormattedMessage
            defaultMessage='<a></a> days'
            description='automationRules.holdOrderFor'
            id='gyIAZg'
            values={{
              a: () => (
                <div>
                  <input
                    disabled={holdIndefinitely}
                    onBlur={onBlur}
                    onChange={onValueChange}
                    type='number'
                    value={holdIndefinitely ? '' : inputValue}
                  />
                </div>
              ),
            }}
          />
        </div>
      </div>
      <div className={classnames(style['multi-control-row'], style['hold-indefinitely-wrap'])}>
        <div className={style['checkbox-wrap']}>
          <Checkbox checked={holdIndefinitely} onChange={onIndefinitelyChange}>
            <span className={style.checkbox}>
              <FormattedMessage {...messages.holdIndefinitely} />
            </span>
          </Checkbox>
        </div>
      </div>
    </div>
  );
};

HoldOrderFor.propTypes = {
  inputValueProps: InputValueProps.isRequired,
  onChange: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  label: PropTypes.node.isRequired,
};

export default HoldOrderFor;
